export default __webpack_public_path__ + "static/media/imagePickAndPackContentFour.ca0547d4.png";